import React from 'react';
import { Search, Download } from '@mui/icons-material';

const statusFilters = [
    { id: 'all', label: 'Tous' },
    { id: 'completed', label: 'Complétés' },
    { id: 'pending', label: 'En attente' },
    { id: 'failed', label: 'Échoués' },
    { id: 'expired', label: 'Expirés' }
];

export const TransactionFilters = ({
    activeTab,
    filters = {},
    onFiltersChange,
    counts = {},
    caisses = [],
    showCaisseFilter = false,
}) => {
    const searchTerm = filters.search || '';
    const filterStatus = filters.status || 'all';
    const filterCaisse = filters.caisse || 'all';

    const getStatusOptions = () => {
        if (activeTab === 'paymentRequests' || activeTab === 'paymentLinks') {
            return statusFilters;
        }
        return statusFilters.filter(f => f.id !== 'expired');
    };

    const handleSearchChange = (value) => {
        onFiltersChange?.({ ...filters, search: value });
    };

    const handleStatusChange = (status) => {
        onFiltersChange?.({ ...filters, status });
    };

    const handleCaisseChange = (caisse) => {
        onFiltersChange?.({ ...filters, caisse });
    };

    const exportData = () => {
        alert(`Export des transactions en cours...`);
    };

    const statusOptions = getStatusOptions();

    return (
        <div className="bg-white rounded-2xl p-6 border border-slate-200 shadow-sm">
            <div className="flex flex-wrap items-center gap-3">
                {/* Barre de recherche */}
                <div className="relative flex-shrink-0">
                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400 text-lg" />
                    <input
                        type="text"
                        placeholder={
                            activeTab === 'all' ? 'Rechercher une transaction...' :
                                activeTab === 'paymentRequests' ? 'Rechercher une demande de paiement...' :
                                    'Rechercher un lien de paiement...'
                        }
                        className="pl-10 pr-4 py-2.5 border border-slate-300 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-all duration-200 w-full min-w-[200px] sm:w-64"
                        value={searchTerm}
                        onChange={(e) => handleSearchChange(e.target.value)}
                    />
                </div>

                {showCaisseFilter && (
                    <select
                        value={filterCaisse}
                        onChange={(e) => handleCaisseChange(e.target.value)}
                        className="px-4 py-2.5 border border-slate-300 rounded-xl focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-all duration-200 text-sm font-medium text-slate-700 bg-white min-w-[220px]"
                        aria-label="Filtrer par caisse"
                    >
                        <option value="all">Toutes les caisses</option>
                        {caisses.map((c) => (
                            <option key={c.id} value={c.id} disabled={!c.cashierId}>
                                {c.cashierName ? `${c.name} · ${c.cashierName}` : `${c.name} · sans caissier`}
                            </option>
                        ))}
                    </select>
                )}

                {/* Filtres de statut sur la même ligne */}
                <div className="flex flex-wrap items-center gap-2">
                    {statusOptions.map(filter => {
                        const count = filter.id === 'all'
                            ? (counts.all || 0)
                            : (counts[filter.id] ?? 0);
                        return (
                            <button
                                key={filter.id}
                                type="button"
                                onClick={() => handleStatusChange(filter.id)}
                                className={`flex items-center space-x-2 px-4 py-2.5 rounded-xl whitespace-nowrap transition-all duration-200 font-medium ${
                                    filterStatus === filter.id
                                        ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-sm'
                                        : 'text-slate-600 hover:text-amber-600 hover:bg-amber-50 border border-slate-200'
                                }`}
                            >
                                <span>{filter.label}</span>
                                <span className={`px-2 py-1 rounded-full text-xs ${
                                    filterStatus === filter.id
                                        ? 'bg-white/20 text-white'
                                        : 'bg-slate-200 text-slate-700'
                                }`}>
                                    {count}
                                </span>
                            </button>
                        );
                    })}
                </div>

                {/* Bouton Exporter */}
                <button
                    type="button"
                    onClick={exportData}
                    className="flex items-center space-x-2 px-6 py-2.5 bg-slate-100 text-slate-700 rounded-xl hover:bg-slate-200 transition-all duration-200 font-semibold shadow-sm ml-auto flex-shrink-0 border border-slate-200"
                >
                    <Download className="text-lg" />
                    <span>Exporter</span>
                </button>
            </div>
        </div>
    );
};

export default TransactionFilters;
